import { CheckIcon } from '../../shared/ui/icons';
import { cn } from '../../shared/lib/cn';
import { STEPS, stepMarks, type TCustomDomain } from '../../entities/custom-domain';

export const DomainSteps = ({ domain }: { domain: TCustomDomain }) => {
  const marks = stepMarks(domain);
  return (
    <ol className="mt-4 flex flex-col gap-2">
      {STEPS.map((step, index) => (
        <li
          key={step}
          className={cn(
            'flex items-center gap-2 text-data',
            marks[index] === 'done' && 'text-muted',
            marks[index] === 'current' && 'font-medium text-primary',
            marks[index] === 'todo' && 'text-faint',
          )}
        >
          <span className="flex size-4 shrink-0 items-center justify-center">
            {marks[index] === 'done' ? (
              <CheckIcon size={12} className="text-success" />
            ) : (
              <span
                className={cn(
                  'size-dot rounded-full',
                  marks[index] === 'current' ? 'bg-primary' : 'border border-border-strong',
                )}
              />
            )}
          </span>
          {step}
        </li>
      ))}
    </ol>
  );
};
